import React, { useContext } from 'react'
import myContext from '../context/context'
import GetSearchResult from '../../Utility/GetSearchResult/GetSearchResult'
import { loadData, isFilterApplied } from '../../Utility/Utility.js'
// import { AuthContext } from '../../../../context/AuthContext'

const ProspectingFilter = () => {

    const { searchCriteria, setSearchCriteria, setSearchResult, setShowSpinner } = useContext(myContext)
    // const keycloak = useContext(AuthContext)

    const removeItem = prospecting => {
        try {
            let index = -1
            if (prospecting.MetropolitanStateAreaName) {
                index = searchCriteria.prospecting.findIndex(x => x.MetropolitanStateAreaName === prospecting.MetropolitanStateAreaName)
            } else {
                index = searchCriteria.prospecting.findIndex(x => x.combinedLocation === prospecting.combinedLocation)
            }

            if (index !== -1) {
                let newSearchCriteria = searchCriteria
                if (newSearchCriteria.prospecting.length === 1) {
                    newSearchCriteria.prospecting = []
                } else {
                    newSearchCriteria.prospecting.splice(index, 1)
                }
                setSearchCriteria(newSearchCriteria)

                setSearchResult({ property: [], totalCount: 0 })

                FetchSearchResult(newSearchCriteria)

            }
        }
        catch (e) {
            console.log('error : ', e)
        }
    }

    const FetchSearchResult = async newSearchCriteria => {
        if (isFilterApplied(newSearchCriteria)) {
            setShowSpinner(true)

            // const searchResult = new GetSearchResult(newSearchCriteria, function (response, isError) {
            //     setShowSpinner(false)
            //     if (!isError) {
            //         loadData(response, newSearchCriteria, setSearchResult)
            //     }
            //     setShowSpinner(false)
            // })
            // searchResult.fetchSearchResult()

            const searchResult = new GetSearchResult(newSearchCriteria, function () { })
            const response = await searchResult.fetchSearchResult()
            setShowSpinner(false)
            loadData(response, newSearchCriteria, setSearchResult)
        }
    }

    const removePOI = () => {
        let newSearchCriteria = searchCriteria
        newSearchCriteria.subjectProperty = {}
        newSearchCriteria.sort = {}
        newSearchCriteria.distanceFields = []
        setSearchCriteria(newSearchCriteria)
        FetchSearchResult(newSearchCriteria)
    }

    const getSelectedValue = value => {
        let returnVal = ''
        if (value.selectedItem === 'propertyCounty') {
            returnVal = value.propertyPropertyCounty
        } else {
            returnVal = value[value.selectedItem]
        }

        return returnVal
    }

    return (
        <>
            {searchCriteria.prospecting ?
                searchCriteria.prospecting.map((value, index) => (
                    <>
                        <div className="capitalize text-primary badge rounded-pill px-5 mr-3 mb-4 py-3 bg-gray-15" key={index}>
                            <span className="cursor-context-menu" title={value.combinedLocation}>
                                {getSelectedValue(value)}
                            </span>
                            <span data-testid={`test-btn-${getSelectedValue(value)}`} onClick={() => removeItem(value)} className="-mr-3">
                                <button type="button">
                                    <i className="fa fa-close"></i>
                                </button>
                            </span>
                        </div>
                    </>
                ))
                : null}

            {/* This is for POI as landmark. This is coming from OV where user has saved landmark in save search like NY university */}
            {searchCriteria.subjectProperty.propertyLocation && searchCriteria.subjectProperty.omniViewPropertyId === '' &&
                <div className="capitalize text-primary badge rounded-pill px-5 mr-3 mb-4 py-3 bg-gray-15" >
                    <span className="cursor-context-menu" title={searchCriteria.subjectProperty.propertyName}>
                        {searchCriteria.subjectProperty.propertyName}
                    </span>
                    <span data-testid={`test-btn-${searchCriteria.subjectProperty.propertyName}`} onClick={() => removePOI()} className="-mr-3">
                        <button type="button">
                            <i className="fa fa-close"></i>
                        </button>
                    </span>
                </div>
            }
        </>
    )
}

export default ProspectingFilter
